import { Container } from 'inversify-props';
import setupCustomerPersonModule from './person/setup';
import setupCustomerPersonalInformationModule from './personal-information/setup';
import setupCustomerNotificationsModule from './customer-notification/setup';
import setupCustomerDocuments from './customer-documents/setup';

export default function setupCustomerModule(container: Container) {
  setupCustomerPersonModule(container);
  setupCustomerPersonalInformationModule(container);
  setupCustomerNotificationsModule(container);
  setupCustomerDocuments(container);
}
